import {
  checkingOnboarding,
  laterOnboarding,
  investOnboarding,
  plaidLayer,
  earlyOnboarding,
} from './flows/index'
import { Flow, FlowEntry } from './types'

type FlowMap = Record<Flow, FlowEntry[]>

const flowMap: FlowMap = {
  laterOnboarding,
  checkingOnboarding,
  earlyOnboarding,
  mocOnboarding: checkingOnboarding,
  investOnboarding,
  plaidLayer,
}

export default flowMap
